import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { Container, Eyebrow, Wordmark } from './primitives'

export function LegalPage({
  eyebrow,
  title,
  updated,
  children,
}: {
  eyebrow: string
  title: string
  updated: string
  children: ReactNode
}) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header style={{ padding: '24px 0', borderBottom: '1px solid var(--line)' }}>
        <Container
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Link to="/" style={{ display: 'inline-flex' }}>
            <Wordmark />
          </Link>
          <Link
            to="/"
            style={{
              fontSize: 13,
              fontFamily: 'var(--mono)',
              color: 'var(--muted)',
            }}
          >
            ← Back to Vello
          </Link>
        </Container>
      </header>
      <main style={{ flex: 1, padding: '80px 0 120px' }}>
        <Container>
          <div className="legal-prose" style={{ maxWidth: 680 }}>
            <Eyebrow>{eyebrow}</Eyebrow>
            <h1
              style={{
                fontFamily: 'var(--serif)',
                fontSize: 'clamp(40px, 6vw, 64px)',
                lineHeight: 1.0,
                letterSpacing: '-0.025em',
                fontWeight: 400,
                margin: '20px 0 8px',
              }}
            >
              {title}
            </h1>
            <div
              style={{
                fontFamily: 'var(--mono)',
                fontSize: 12,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: 'var(--muted)',
                marginBottom: 48,
              }}
            >
              Last updated {updated}
            </div>
            {children}
          </div>
        </Container>
      </main>
    </div>
  )
}
